export default (state = { code: '100011'}, action) => {
  switch (action.type) {
    case 'SET_CUSTOMER':
      return { ...state, ...action.p };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/customer.js